// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2m4ku","left":"styles_left__mZw4k","desktopActions":"styles_desktopActions__16afi","title":"styles_title__24Mga"};